import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.994 15H22v2h-9a2 2 0 01-2-2h-.006V7.492l-3.23 3.23L6.35 9.306l5.657-5.657 5.657 5.657-1.415 1.414-3.255-3.256V15z"
    />
  </svg>
);
